import {Component} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SessionService} from './services/session.service';
import {Meta} from '@angular/platform-browser';
import {DialogService} from './services/dialog.service';
import {LoaderService} from './services/loader.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'FAD Masivo';
    masInfo = false;
    mostrarCookies = true;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    countryVisit: any = false;
    cookies: any;
    subscriptions: Subscription[] = [];
    public loading: boolean;
    public timer: any;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private loaderService: LoaderService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.countryVisit = this.sessionService.getCountryData() === 'México';
        this.cookies = this.sessionService.getCountryData();
        this.subscriptions.push(
            this.loaderService.awaitLoader().subscribe(
                action => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.loading = action;
                    }, 5);
                }
            )
        );
        setTimeout(() => {
            if (this.cookies === null) {
                dialogService.showPromo();
            }
        }, 3000);
    }

}
